// extracted by mini-css-extract-plugin
export var box = "_69-1";
export var checkboxRow = "_69-8";
export var checked = "_69-2";
export var descriptionSpacer = "_69-a";
export var disabled = "_69-3";
export var icon = "_69-6";
export var input = "_69-0";
export var labelSpacer = "_69-9";
export var medium = "_69-5";
export var small = "_69-4";
export var text = "_69-7";